import { Chip, TableCell } from '@mui/material'

import { TESSERE } from '../../settings/settings'

const TableCellRuolo = ({ ruolo }) => {
  const color = TESSERE?.find(t => t.key === ruolo)?.color || 'default'

  return (
    <TableCell>
      <Chip variant='outlined' color={color} label={ruolo} />
    </TableCell>
  )
}

export default TableCellRuolo
